// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "a.disabled[data-v-35be911f]{pointer-events:none;color:rgba(0,0,0,.75)}@media (max-width:960px){.logo[data-v-35be911f]{height:45px!important}}.logo[data-v-35be911f]{height:50px}", ""]);
// Exports
module.exports = exports;
